// Le moment d'un match (D-058), pour ouvrir la fiche au bon onglet : « avant » (préparer,
// convoquer, partir), « direct » (le score en cours), « après » (résumé, stats, photos).
// Logique pure, horloge injectée.

export type Phase = 'avant' | 'direct' | 'apres';

export function phaseOf(start: Date, m: { live?: boolean; score_us: number | null; score_them: number | null; forfeit?: string | null },
  now: Date = new Date()): Phase {
  if (m.live) return 'direct';
  if (m.forfeit || (m.score_us !== null && m.score_them !== null)) return 'apres';
  const t = now.getTime(), s = start.getTime();
  if (t < s - 30 * 60_000) return 'avant';
  if (t < s + 3 * 3600_000) return 'direct';
  return 'apres';
}

/** La saisie des stats (D-103) : « direct » avant et pendant le match ; « après coup » une fois le match
 *  joué (score enregistré, forfait, ou coup d'envoi passé de 3 h) et hors direct. Après coup, la saisie
 *  ne passe jamais le match en direct et ne touche jamais au score. */
export function statsMode(start: Date, m: { live?: boolean; score_us: number | null; score_them: number | null; forfeit?: string | null },
  now: Date = new Date()): 'live' | 'after' {
  return !m.live && phaseOf(start, m, now) === 'apres' ? 'after' : 'live';
}

/** Après coup : la saisie face au score du match. « same » : tout concorde ; « diff » : le score peut
 *  être remplacé (sur demande, une fois toutes les actions marquées saisies) ; « none » : aucun panier saisi. */
export function scoreCheck(official: { us: number | null; them: number | null }, entered: { us: number; them: number }): 'none' | 'same' | 'diff' {
  if (!entered.us && !entered.them) return 'none';
  return official.us === entered.us && official.them === entered.them ? 'same' : 'diff';
}

/** « AUJOURD'HUI », « DEMAIN », « DANS 3 JOURS » ; null une fois passé. */
export function countdown(matchDay: string, today: string): string | null {
  const d = Math.round((Date.parse(`${matchDay}T12:00:00Z`) - Date.parse(`${today}T12:00:00Z`)) / 86400_000);
  if (d < 0) return null;
  return d === 0 ? 'aujourd’hui' : d === 1 ? 'demain' : `dans ${d} jours`;
}

/** La lettre de l'adversaire dans son rond : le mot le plus long (« ASC Valdorne » → A). */
export const opponentInitial = (name: string) =>
  (name.split(/[\s-]+/).filter(Boolean).sort((a, b) => b.length - a.length)[0] ?? '?').charAt(0).toUpperCase();
